export const setDocumentTitleCount = (count: number, max = 99): void => {
  if (count > 0) {
    const limitedCount = count > max ? `${max}+` : count; // e.g. "99+"
    document.title = `(${limitedCount}) ${pureTitle()}`;
  } else {
    document.title = pureTitle();
  }
};

const leadingParenthetical = /^\s*\([^)]*\)\s*/;
const pureTitle = (): string => {
  return document.title.replace(leadingParenthetical, '');
};
